import React from 'react';

import {
  Box,
  Stack,
  styled,
  Typography
} from '@mui/material';

import * as ImageCarousel from './components/ImageCarousel';



const ContainerBox = styled(Box)(({ theme }) => ({
}));

const TypographyStack = styled(Stack)(({ theme }) => ({
  marginBottom: theme.spacing(7)
}));

const ImageCarouselBox = styled(Box)(({ theme }) => ({
  marginLeft: -60,
  marginRight: -60
}));


export const FC: React.FC = () => {
  return (
    <ContainerBox>
      <TypographyStack spacing={2}>
        <Typography variant="h2" color="#FFFFFF">Pitch Construction Trends</Typography>
        <Typography color="#C3D1D8">What about ordering and construction? First impressions matter. A well-constructed pitch deck, with an investor perspective incorporated into the construction, can be the difference between an intro meeting and immediate rejection.</Typography>
        <Typography color="#C3D1D8">Here's what we are seeing in a typical early and venture-stage pitch deck, based on our running, representative sample.</Typography>
      </TypographyStack>

      <ImageCarouselBox>
        <ImageCarousel.FC imageUrls={[
          'pitch_deck_pitch_construction_slide_1.png',
          'pitch_deck_pitch_construction_slide_2.png'
        ]} />
      </ImageCarouselBox>
    </ContainerBox>
  );
};
